import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classificationTableTranslations() {
  return {
    number: {
      text: $localize`:@@config.classificationTable.header.number:Class #`,
      desc: 'Header text for column classification number.',
    },
    name: {
      text: $localize`:@@config.classificationTable.header.name:Description`,
      desc: 'Header text for column classification name.',
    },
    color: {
      text: $localize`:@@config.classificationTable.header.color:Point Style`,
      desc: 'Header text for column classification color.',
    },
    visibility: {
      text: $localize`:@@config.classificationTable.header.visibility:Default 3D Visibility`,
      desc:
        'Header text for column classification visibility which sets the default visibilty ' +
        'when viewing model classifications in 3D.',
    },
    delete: {
      text: $localize`:@@config.classificationTable.header.delete:Delete`,
      desc: 'Header text for the column that contains the button to delete a classification.',
    },
    add: {
      text: $localize`:@@config.classificationTable.add:Add Classification`,
      desc: 'Tooltip text for the button to add a new classification.',
    },
    placeholders: {
      number: {
        text: $localize`:@@config.classificationTable.placeholders.number:Class #`,
        desc: 'Placeholder text for the classification number input field.',
        limit: 10,
      },
      name: {
        text: $localize`:@@config.classificationTable.placeholders.name:Description`,
        desc: 'Placeholder text for the classification name input field.',
      },
    },
    deleteConfirmation: {
      title: {
        text: $localize`:@@config.classificationTable.deleteConfirmation.title:Delete Classification`,
        desc: 'Title for the delete classification confirmation dialog.',
      },
      message: {
        text: $localize`:@@config.classificationTable.deleteConfirmation.message:Are you sure you want to delete this classification?`,
        desc: 'Message for the delete classification confirmation dialog.',
      },
      confirm: {
        text: $localize`:@@config.classificationTable.deleteConfirmation.confirm:Delete`,
        desc: 'Text for the button to confirm deletion of a classification.',
      },
    },
  } satisfies TranslationMap;
}
